import { Container } from './Container'

type Props = {
	label: string | undefined
	icon: ((props: { size?: number }) => React.JSX.Element) | undefined
}

export const InlineValue = ({ label, icon }: Props) => (
	<Container>
		{icon?.({ size: 22 })}
		{label}
	</Container>
)
